import UserRepository from "../../ports/userRepository";
import { User } from "../../../entities/user";

export type fetchUserByIdUsecase = (uid: string) => Promise<User>;

export const buildFetchUserById = (dependencies: {
  userRepo: UserRepository;
}): fetchUserByIdUsecase => {
  const { userRepo } = dependencies;

  const fetchUserById = async (uid: string) => userRepo.fetchUserById(uid);

  return fetchUserById;
};
